import * as React from 'react';
import classNames from 'classnames';

import { DynamicMediaItem, View } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { Container, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import { TaxonomyGeneric } from '../../../../types/uncinc_profile/taxonomy';
import { Breadcrumbs, ParagraphsRenderer } from '../../../../components';

import './style.scss';

interface TaxonomyGenericPageProps {
  entity: ImmutableEntity<TaxonomyGeneric>;
}

const TaxonomyGenericPage: React.FC<TaxonomyGenericPageProps> = ({ entity, ...props }) => {
  const classes = classNames('Taxonomy Taxonomy-type-breadcrumbs TaxonomyGeneric');
  const taxonomy = entity.toJS();
  const tid = taxonomy.tid[0].value;
  const name = taxonomy.name[0].value;
  const body = taxonomy.description[0].value;
  const labelIds = taxonomy.field_labels.map((label) => label.target_id);
  const heroImage = taxonomy.field_media_item[0];
  const target = taxonomy.vid?.[0]?.target_id;
  const fieldTargetKey = target ? `field_${target}_target_id` : 'field_type_target_id';

  return (
    <article itemType="http://schema.org/WebPage" className={classes}>
      <Container>
        <div className="row">
          <div className="col-12 col-md-8 offset-md-2">
            <Breadcrumbs />
            <h1 className="TaxonomyGeneric__title">{name}</h1>
            <WysiwygField html={body} className="TaxonomyGeneric__body" />
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            {heroImage && (
              <DynamicMediaItem
                className="TaxonomyTheme__image"
                media={heroImage}
                imageAspectRatio="16_9"
              />
            )}
          </div>
        </div>
      </Container>

      <ParagraphsRenderer paragraphs={entity.get('field_paragraphs')} />

      <Container>
        <View
          id="projects_filtered"
          display="related"
          filters={{
            [fieldTargetKey]: [tid],
            field_labels_target_id: labelIds.length > 0 ? labelIds.join('+') : [],
          }}
        />
      </Container>

    </article>
  );
};

export default TaxonomyGenericPage;
